export const dataAuthCxpFacProv = [
    { key: 'IUsuario', name: 'user' },
    { key: 'IUuid', name: 'uuid' },
    { key: 'IEstatus', name: 'status' },
];